import { render, staticRenderFns } from "./download_button.vue?vue&type=template&id=3f9f1da0"
import script from "./download_button.vue?vue&type=script&lang=js"
export * from "./download_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports